import React from 'react';
import Dropzone from 'react-dropzone';
import EtelAPI from '../api/EtelAPI';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Alerts from '../prototypes/Alerts';

/* Renders inside a DropZone container and allows for clicking to remove
   the item clicked */
class FileView extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {filename: this.props.filename,
      style: this.props.viewStyle,
      file: this.props.file,
      canremove: this.props.canremove === undefined ? true : this.props.canremove,
      hasError: false,
      error: {},
      info: {}
    };

    this.onClickRemove = this.onClickRemove.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  /* Removes the selected item from the container stopping the propagation
     of other click events to follow*/
  onClickRemove( e ) {
    if( this.state.canremove ){
      // Calls the prop function
      this.props.onClickRemove( this.state.file );
    }

    // Prevents the click from going through this element
    e.stopPropagation();
  }


  render() {
    // Returns the view render for this component
    return ( <div className={this.state.style}>
      <span onClick={this.onClickRemove}>{this.state.filename}</span>
    </div> );
  }
}

/* React Component that enables drag and drop file support*/
class FileUpload extends React.Component {
  constructor( props ) {
    super( props );

    // upload_type is set to -1 if not defined
    var utype;
    if( props.upload_type === undefined ) {
      utype = -1;
    } else {
      utype = parseInt( props.upload_type, 10 );
    }

    let files = this.props.files === undefined ? [] : this.props.files;
    let newDrop = true;
    if ( files.length > 0 ){
      newDrop = false;
    }

    // Component state items
    this.state = { 
      files: files,
      accepted_files: [],
      uploaded_files: [],
      group_name: this.props.group_name,
      defdnis: this.props.defdnis,
      description: this.props.description,
      new_drop: newDrop,
      upload_type: utype,
      canremove: this.props.canremove === undefined ? true : this.props.canremove,
      hasError: false
    };

    // Bindings
    this.onClickToSend = this.onClickToSend.bind( this );
    this.readFile = this.readFile.bind( this );
    this.onClickToClear = this.onClickToClear.bind( this );
    this.onClickRemove = this.onClickRemove.bind( this );
    this.onSelectionChange = this.onSelectionChange.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    var utype;
    if( nextProps.upload_type === undefined ) {
      utype = -1;
    } else {
      utype = parseInt( nextProps.upload_type, 10 );
    }

    this.setState( {
      group_name: nextProps.group_name,
      defdnis: nextProps.defdnis,
      description: nextProps.description,
      upload_type: utype,
      globalList: nextProps.globalList,
      files: nextProps.files,
      canremove: nextProps.canremove === undefined ? true : nextProps.canremove
    } );
  }

  /* What changes occur when a file is dropped in the DropZone component */
  onDrop( files ) {
    // Checks against a global list of file names (for multiple components that are tide in)
    if( this.props.globalList !== undefined ){

      var global_files = this.props.globalList;
      var nfiles = [];

      // Checking global_files against dropped files
      for( var x = 0; x < files.length; x++ ) {
        var pass_check = true;
        var filename = files[x]['name'];
        for( var y = 0; y < global_files.length; y++ ) {
          if( filename === global_files[y] ) {
            pass_check = false;
            break;
          }
        }

        // Pushing (appending) if unique
        if( pass_check ) {
          nfiles.push( files[x] );
        }
      }

      // Redefine files to use new filtered files (nfiles)
      files = nfiles;
    }

    // State data
    let fp = this.state['files'];
    let accepted_files = this.state['accepted_files'];
    // FLAG
    //let duplicate;
    /*
      This is not bullet proof, a malicious/dumb user can still send bad
      data over if they change the extension to be a ".txt" file, for example
      "x.csv or x.exe" -> "x.txt" will get pass this check. The reason is
      that browsers does not read an entire file, only a few bytes to determine
      its composition. This standard is defined in the MIME-Type; the MIME-Type
      definition for a csv and a text file are the same.
    */
    if( files.length !== 0 ){
      for( var index = 0; index < files.length; index++ ) {
        const f = files[ index ];
        // Checks for size, name, and extension
        if( f.size !== 0 && ( f.name.includes( '.txt' ) === true || f.name.includes( '.csv' ) === true ) ) {
          let duplicate = false;
          for( var sindex = 0; sindex < accepted_files.length; sindex++ ){
            const nf = accepted_files[ sindex ];
            if( nf.name === f.name ) {
              duplicate = true;
            }
          }
          // Prevents name duplicates not content duplicates
          if( duplicate === false ) {
            // Setting to default type (callable from the actual file object)
            f.upload_type = this.state.upload_type;
            f.group_name = this.state.group_name;
            f.defdnis = this.state.defdnis;
            f.description = this.state.description;
            // Appending to files
            accepted_files.push( f );
            fp.push( f );
            this.setState( { new_drop: false} );
          } else {
            const { dispatch } = this.props;
            const Bugsnag = this.props.bugsnag;
            const alerts = new Alerts( Bugsnag, dispatch );
            alerts.WARNING( 'File Upload', 'You cannot upload files with duplicate names.', 3000 );
          }
        }
      }
    }

    // Changing the entire state, this isn't the most efficient
    // way but works. Changing the element prop would be "better",
    // but as the data represented is small, this doesn't have a massive
    // impact.

    this.setState( {
      files: fp
    } );

    // This will send the files (to upload) over to the parent container
    if( this.props.onDropFile !== undefined ){
      if( fp.length === 0 ){
        this.props.onDropFile( { action: 'none', files: fp } );
      } else {
        this.props.onDropFile( { action: 'add', files: fp } );
      }
    }
  }


  /* Reads files drop in DropZone */
  readFile( file ){
    // File
    const reader = new FileReader();
    let filename = file.name;
    // State
    let fp = this.state['files'];
    let up = this.state['uploaded_files'];
    // Reference
    var self = this;

    // Reading the entire content of the file as
    // text and setting where to store it's contents (reference)
    reader.readAsText( file );
    reader.onload = function ( e ) {
    };

    /*
      Sends the data over on completed read, missing columns are
      either filled in by the backend or lefts ommited because they
      are no longer used.
    */
    reader.onloadend = function( e ) {
      if( e.target.readyState === FileReader.DONE ) {
        var fd = new FormData();
        /*
          -- Enterprise.dbo.FILE_UPLOAD_CONTENTS
            [GROUP_NAME],[FILENAME],[NUMBER],[PROCESSED],[NOTES]
        */
        fd.append( 'GROUP_NAME', this.state.group_name );
        fd.append( 'FILENAME', filename );
        fd.append( 'NOTES', 'rmq_TEST Data' );

        /* Seperates files uploaded using the old way (10) from this control (11) */
        fd.append( 'STATUS', 11 );
        /*
          -- Enterprise.dbo.FILE_UPLOAD
            [GROUP_NAME],[UPLOAD_TYPE],[DEFDNIS],[DESCRIPTION],[FILENAME],[STATUS],[NOTES],[PAUSE_BETWEEN_STEPS],[COUNT_NEW],
            [COUNT_PROCESSED],[COUNT_ERROR],[COUNT_DUPS],[COUNT_TOTAL],[COUNT_OTHER],[COUNT_OTHER_DESC],[CreateOnDate],
            [CreateByUser],[DESTINATION],[REACT_USER_ID]
        */
        fd.append( 'UPLOAD_TYPE', file.upload_type );
        fd.append( 'DEFDNIS', this.state.defdnis );
        fd.append( 'DESCRIPTION', this.state.description );
        /*
          DECLARE @UPLOAD_DESTINATION_LEADGEN    INT = 1
          DECLARE @UPLOAD_DESTINATION_PROGRAM    INT = 2
          DECLARE @UPLOAD_DESTINATION_GLS        INT = 3
        */
        fd.append( 'DESTINATION', 1 );

        // The actual files content
        fd.append( 'FILE', reader.result );

        // Adding it to uploaded files
        up.push( file );
        // Changing the state
        fp.splice( fp.indexOf( file ), 1 );
        self.setState(
          {
            uploaded_files: up,
            files: fp
          } );
        // Sending the file to the backend
        self.sendFile( fd, filename );
      }
    };
  }


  /* Sends a file using the etelAPI */
  sendFile( formdata, filename ){

    let api = new EtelAPI( 'files' );
    api.sendFile( formdata ).then( ( result ) => {

      return result;

    } ).catch( ( error ) => {

      alert( filename + ' already exist' );
      return error;

    } );
  }


  /* Perform the sendFile operation on valid files */
  onClickToSend( ) {
    const files = this.state.files;
    /* let formData = new FormData(); */
    for( var index = 0;index < files.length; index++ ) {
      const file = files[ index ];
      this.readFile( file );
    }
  }


  /* Developer only, clears the data */
  onClickToClear(){
    this.setState( {
      files: [],
      accepted_files: [],
      uploaded_files: [],
      new_drop: true} );
  }


  /* Removes a single item */
  onClickRemove( e ){

    // This is an event trigger
    var file = e;
    //State
    let fp = this.state['files'];
    let nfp = [];
    let accepted = this.state['accepted_files'];
    let new_accepted = [];

    // Checking each file for a match
    for( var a=0; a < fp.length; a++ ) {
      if( fp[a] !== file ) {
        nfp.push( fp[a] );
      }
    }

    // Removing the file from the accepted files as well
    for( var b=0; b < accepted.length; b++ ) {
      if( accepted[b] !== file ) {
        new_accepted.push( accepted[b] );
      }
    }

    // Updating the state
    this.setState( {
      accepted_files: new_accepted,
      files: nfp
    } );

    // Clear on only 1 file left (1 removed will mean the element is empty)
    if( this.state['files'].length === 1 ) {
      this.setState( { new_drop: true, files: [],
        accepted_files: [],
        uploaded_files: [] } );
    }

    // This will send the files (to upload) over to the parent container
    if( this.props.onDropFile !== undefined ){
      this.props.onDropFile( { action:'remove', files:[file] } );
    }
  }


  /* Changes the file upload_type */
  onSelectionChange( file, event ){
    let upload_type = parseInt( event.target.value, 10 );
    let fp = this.state['files'];
    let nfp = [];

    for( var i=0; i < fp.length; i++ ) {
      if( fp[i] === file ) {
        let new_file = fp[i];
        new_file.upload_type = upload_type;
        nfp.push( new_file );
      } else {
        nfp.push( fp[i] );
      }
    }

    // Updating the state
    this.setState( {
      files: nfp
    } );
  }


  /* Renders the actual DropZone component */
  render(){
    let has_error = this.state.hasError === undefined ? false : this.state.hasError;
    if( has_error === false ) {

      if( this.state.new_drop ) {
        // Renders a new 'undropped component'
        return (
          <div className={this.props.containerStyle}>
            <Dropzone
              className={this.props.dropZoneStyleClass}
              onDrop={this.onDrop.bind( this )}>
              <p className={this.props.text_style}>Drop files to attach, or click to browse.</p>
            </Dropzone>
          </div>
        );
      } else {
        return(
          // Renders the component with FileView components embedded
          <div className={this.props.containerStyleAfter}>
            <Dropzone className={this.props.dropZoneStyleClass}
              onDrop={this.onDrop.bind( this )}>
              {
                this.state.files.map( f => <FileView key={f.name + f.text} canremove={this.state.canremove} filename={f.name} file={f} onClickRemove={this.onClickRemove} viewStyle={this.props.viewTextStyle}></FileView> )
              }
            </Dropzone>
          </div>
        );
      }

    } else {
      return ( <span></span> );
    }
  }
}


export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( FileUpload,FileView ) );


// WEBPACK FOOTER //
// ./src/presentation/FileUpload.js